import React from "react";
import Header from "@/bit/components/next13.components.header";
import Footer from "@/bit/components/next13.components.footer";
import MetaData from "@/bit/core/next13.core.meta-data";
import { wrapper } from "@/store";
import { connect } from "react-redux";
import dynamic from "next/dynamic";
import LayoutFicha from "@/layouts/fichas";
import LayoutDistri from "@/layouts/distri";
import {
  getStaticPaths as getStaticPathsMethod,
  getStaticProps as getStaticPropsMethod,
} from "@gerenciatd/next13.pages.create-pages";
import normalizeOrionModule from "@/bit/normalizers/next13.normalizers.orion";

const Error500 = dynamic(() => import("@/pages/500"));

class Public extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orionInfo: props.orionInfo,
    };
  }

  async handleRehydrate() {
    const module = await import(
      "@gerenciatd/next13.adabyron.orion.get-by-alias"
    );
    const { context, orionAlias } = this.props;
    const getByAlias = module.default;

    if (orionAlias && context) {
      const orionInfoData = await getByAlias({
        alias: orionAlias,
        context: context,
        build: false,
      });

      const orionInfo = await normalizeOrionModule(
        orionInfoData,
        context,
        orionAlias
      );

      console.log("rehydrate");
      this.setState((prev) => ({ ...prev, orionInfo: { ...orionInfo } }));
    }
  }

  componentDidMount() {
    if (
      typeof window !== "undefined" &&
      `${process.env.NEXT_PUBLIC_ENV_NAME}` === "qa"
    ) {
      this.handleRehydrate();
    }
  }

  render() {
    const filePath = "/pages/index/";
    const {
      breadcrumbsProps,
      footerProps,
      headerProps,
      seoInfo,
      orionAlias,
      layoutInfo,
    } = this.props;
    const { orionInfo } = this.state;

    if (!orionInfo) {
      return <Error500 {...{ footerProps, headerProps }} />;
    }

    return (
      <>
        <MetaData seoInfo={seoInfo} />
        <Header {...breadcrumbsProps} {...headerProps} />
        {layoutInfo === "ficha" && (
          <LayoutFicha {...orionInfo} productName={orionAlias} />
        )}
        {layoutInfo === "distri" && (
          <LayoutDistri {...orionInfo} productName={orionAlias} />
        )}
        <Footer footerProps={footerProps} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Public);

const getStaticPaths = () =>
  getStaticPathsMethod("particulares%5Bfichas%5D", 3);
export { getStaticPaths };

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, "particulares%5Bfichas%5D", 3);
});
